import Ajax from '../../../../util/ajax';
export function zigbeeMoveToLevelWithOnOff(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/8/command/move-to-level-with-on-off';
        const value = {
            'level': payload.level,
            'transition time': payload.transitionTime
        };
        ajax.post(url, value);
    };
}
